import React from 'react';
import {
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: "column",
        height: "100%",
        paddingLeft: "16px",
    },
    heading: {
        color: theme.palette.primary.textColor,
        width: "100%",
        fontWeight: 600,
        fontSize: "40px"
    },
    firstName: {
        color: theme.palette.primary.textColor,
        fontSize: "72px",
        fontWeight: 600
    },
    lastName: {
        color: theme.palette.primary.main,
        fontSize: "72px",
        fontWeight: 600
    },
    skillHeaderDiv: {
        paddingTop: "24px"
    },
    skillHeader: {
        fontSize: "24px",
        fontWeight: 600
    },
    skillBullets: {
        paddingTop: "12px",
        display: "flex",
        flexDirection: "column",
        paddingBottom: "12px"
    },
    designation: {
        fontSize: "22px",
        fontWeight: 500
    },
    icon: {
        fontSize: "48px",
        cursor: "pointer",
        "&:hover": {
            color: theme.palette.primary.main
        }
    },
    checkIcon: {
        fontSize: "16px",
        marginRight: "12px",
        marginTop: "4px"
    },
    checkList: {
        display: "flex",
        flexDirection: "row",
        alignItems: "top"
    },
}));

const Achievements = () => {
    const classes = useStyles();

    return (
        <Typography component="div" className={classes.root}>
            <Typography component="div" className={classes.heading}>ACHIEVEMENTS</Typography>
            <Typography component="div" className={classes.skillHeaderDiv}>
                <Typography component="span" className={classes.skillHeader}>Job related</Typography>
            </Typography>
            <Typography component="div" className={classes.skillBullets}>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Researched and developed a relatively new concept called microfrontends which are similar to microservices but microfrontends will serve an entire frontend along with the server functionality. This is now being used across many applications in Synamedia.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Received star of the sprint award multiple times.</Typography>
            </Typography>
            <Typography component="div" className={classes.skillHeaderDiv}>
                <Typography component="span" className={classes.skillHeader}>Others</Typography>
            </Typography>
            <Typography component="div" className={classes.skillBullets}>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Qualified in GATE 2013 (CSE).</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Represented UVCE at SAP Lumira Visualization Hackathon held at SAP Labs, Bangalore in 2013.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Represented CIT at PLEIADES-12 held at BVBCET, Hubli in 2012.</Typography>
                <Typography component="span" className={classes.checkList} ><ArrowForwardIosIcon className={classes.checkIcon} />Presented a poster “Virtual Network Computing” in K-New 2011 at CIT.</Typography>
            </Typography>
        </Typography>
    );
}

export default Achievements;
